import { Block } from 'baseui/block';
import { LabelLarge } from 'baseui/typography';
import { themedUseStyletron } from '../../../theme/customTheme';
import { IMultiState } from './types'
import { Badge } from 'baseui/badge';

export function SmallPanel(props: IMultiState) {
  const [, theme] = themedUseStyletron();
  
  return (
    <Badge hierarchy='secondary' color='accent' content={props.actStateText} />
  );
}